"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_RO_TRANS = {
    'time picker': 'Selector Timp',
    'today': 'Astăzi',
    'set time': 'Setează Ora',
    'close': 'Închide',
    'cancel': 'şterge',
    'confirm': 'Confirmă',
    'hour': 'Oră',
    'minute': 'Minut',
    'second': 'Secondă',
};
//# sourceMappingURL=ro.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ng-pick-datetime/locale/ro.js
// module id = ../../../../ng-pick-datetime/locale/ro.js
// module chunks = 15